export function isMenuCollapsed(): boolean {
  const combinedMenu = document.getElementsByTagName('dmb-combined-menu');
  return combinedMenu[0]?.classList.contains('collapsed');
}
